import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useCurrentScreenWidth from "./Dimension";

const Header = () => {
  let width = useCurrentScreenWidth();

  const [buttonStyle1, setButtonStyle1] = useState({
    width: 100,
    height: 50,
    borderRadius: 15,
    border: "none",
    backgroundColor: "white",
    color: "#1877f3",
    cursor: "pointer",
    fontWeight: 700,
  });

  const [buttonStyle2, setButtonStyle2] = useState({
    width: 100,
    height: 50,
    borderRadius: 15,
    border: "none",
    backgroundColor: "white",
    color: "#1877f3",
    cursor: "pointer",
    fontWeight: 700,
  });

  const [buttonStyle3, setButtonStyle3] = useState({
    height: 50,
    width: 50,
    backgroundColor: "white",
    borderRadius: 25,
    border: "none",
    cursor: "pointer",
  });

  const [buttonStyle4, setButtonStyle4] = useState({
    height: 50,
    width: 50,
    backgroundColor: "white",
    borderRadius: 25,
    border: "none",
    cursor: "pointer",
  });

  const [buttonStyle5, setButtonStyle5] = useState({
    height: 50,
    width: 50,
    backgroundColor: "white",
    borderRadius: 25,
    border: "none",
    cursor: "pointer",
  });

  const [currentPath, setCurrentPath] = useState(useLocation().pathname);
  const [title, setTitle] = useState("");

  useEffect(() => {
    setCurrentPath(window.location.pathname);
    if (currentPath === "/") {
      setTitle("Home");
    } else if (currentPath === "/popular") {
      setTitle("Popular");
    } else if (currentPath === "/new") {
      setTitle("Post");
    } else if (currentPath === "/settings") {
      setTitle("Settings");
    } else if (currentPath === "/feedback") {
      setTitle("Feedback");
    } else if (currentPath === "/auth") {
      setTitle("Account");
    } else if (currentPath === "/u") {
      setTitle("My Profile");
    } else if (currentPath.startsWith("/u/")) {
      setTitle("Profile");
    } else {
      setTitle("404");
    }
  });

  return (
    <header
      style={{
        height: "60px",
        backgroundColor: "white",
        boxShadow: "rgba(0, 0, 0, 0.5) 0px 0px 30px",
        position: "fixed",
        width: "100vw",
        top: 0,
        zIndex: 100
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
          width: "100%",
          padding: 0,
          margin: 0,
        }}
      >
        <div style={{ width: 200 }}>
          <Link to="/">
            <img
              src="/logo4.png"
              alt="logo"
              height="50px"
              style={{ marginTop: 5, marginLeft: 5 }}
            />
          </Link>
          {width > 600 ? (
            <Link
              to="/"
              style={{
                fontSize: 24,
                fontWeight: 700,
                position: "absolute",
                top: 12,
                textOverflow: "ellipsis",
                width: "calc(50vw - 150px)",
                height: 45,
                overflow: "hidden",
                textDecoration: "none",
                color: "black",
              }}
            >
              {title}
            </Link>
          ) : (
            <span
              style={{
                fontSize: 24,
                fontWeight: 700,
                position: "absolute",
                top: 12,
                textOverflow: "ellipsis",
                width: "calc(100vw - 250px)",
                height: 45,
                overflow: "hidden",
              }}
            >
              {title}
            </span>
          )}
        </div>
        {width > 600 ? (
          <div style={{ height: "100%", textAlign: "center" }}>
            <Link
              to="/"
              style={{
                lineHeight: "60px",
              }}
            >
              <button
                style={buttonStyle1}
                onMouseEnter={() => {
                  setButtonStyle1({
                    width: 100,
                    height: 50,
                    borderRadius: 15,
                    border: "none",
                    backgroundColor: "whitesmoke",
                    color: "#1877f3",
                    cursor: "pointer",
                    fontWeight: 700,
                  });
                }}
                onMouseLeave={() => {
                  setButtonStyle1({
                    width: 100,
                    height: 50,
                    borderRadius: 15,
                    border: "none",
                    backgroundColor: "white",
                    color: "#1877f3",
                    cursor: "pointer",
                    fontWeight: 700,
                  });
                }}
              >
                Home
              </button>
            </Link>
            <Link
              to="/popular"
              style={{
                lineHeight: "60px",
              }}
            >
              <button
                style={buttonStyle2}
                onMouseEnter={() => {
                  setButtonStyle2({
                    width: 100,
                    height: 50,
                    borderRadius: 15,
                    border: "none",
                    backgroundColor: "whitesmoke",
                    color: "#1877f3",
                    cursor: "pointer",
                    fontWeight: 700,
                  });
                }}
                onMouseLeave={() => {
                  setButtonStyle2({
                    width: 100,
                    height: 50,
                    borderRadius: 15,
                    border: "none",
                    backgroundColor: "white",
                    color: "#1877f3",
                    cursor: "pointer",
                    fontWeight: 700,
                  });
                }}
              >
                Popular
              </button>
            </Link>
          </div>
        ) : (
          <></>
        )}
        <div style={{ marginTop: 5, width: 200 }}>
          <span>
            <Link
              to="/new"
              style={{
                width: 50,
                height: 50,
                lineHeight: "60px",
                marginLeft: 5,
                marginRight: 5,
                borderRadius: 25,
              }}
            >
              <button
                style={buttonStyle5}
                onMouseEnter={() => {
                  setButtonStyle5({
                    height: 50,
                    width: 50,
                    backgroundColor: "whitesmoke",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                onMouseLeave={() => {
                  setButtonStyle5({
                    height: 50,
                    width: 50,
                    backgroundColor: "white",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                className="material-icons"
              >
                add_circle_outline
              </button>
            </Link>
          </span>
          <span>
            <Link
              to="/settings"
              style={{
                width: 50,
                height: 50,
                lineHeight: "60px",
                marginLeft: 5,
                marginRight: 5,
                borderRadius: 25,
              }}
            >
              <button
                style={buttonStyle3}
                onMouseEnter={() => {
                  setButtonStyle3({
                    height: 50,
                    width: 50,
                    backgroundColor: "whitesmoke",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                onMouseLeave={() => {
                  setButtonStyle3({
                    height: 50,
                    width: 50,
                    backgroundColor: "white",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                className="material-icons"
              >
                settings
              </button>
            </Link>
          </span>
          <span>
            <Link
              to="/u"
              style={{
                width: 60,
                height: 60,
                lineHeight: "60px",
                marginLeft: 5,
                marginRight: 5,
                borderRadius: 25,
              }}
            >
              <button
                style={buttonStyle4}
                onMouseEnter={() => {
                  setButtonStyle4({
                    height: 50,
                    width: 50,
                    backgroundColor: "whitesmoke",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                onMouseLeave={() => {
                  setButtonStyle4({
                    height: 50,
                    width: 50,
                    backgroundColor: "white",
                    borderRadius: 25,
                    border: "none",
                    cursor: "pointer",
                  });
                }}
                className="material-icons"
              >
                face
                {/* user profile image */}
              </button>
            </Link>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
